import * as React from 'react';
import { EditComponent,CreateComponent, CustomComponentProps } from 'src/components/common/Component';

export function SheetEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function SheetCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"Sheet"} children={children} />
    );
}